<template>
  <div>
    <div class="feedbackBut" v-if="feedback" @click="feedback = false">
      <i class="icon iconfont icon-edit"></i>
      <p class>反馈</p>
    </div>
    <div class="feedbackCon" v-else>
      <div class="content">
        <div class="content-header">
          <p class>期待您的反馈</p>
          <i class="icon iconfont icon-close" @click="feedback = true"></i>
        </div>

        <div class="feedbackForm">
          <textarea
            placeholder="意见或反馈(最多140个字)"
            type="textarea"
            v-model="commitForm.content"
            class="feed-input opinion-input"
          ></textarea>
          <!-- <div class="pic-upload">
            <el-upload
              action="/apiApp/profile"
              list-type="picture-card"
              :limit="3"
              :on-success="handleSuccess"
              accept=".jpg,.png"
              ref="upload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
          <div style="color: #aaa; font-size: 12px">
            最多上传3张，每张不超过2M
          </div> -->
          <div class="input-wrapper">
            <input
              type="text"
              placeholder="联系方式(电话或邮箱)"
              v-model="commitForm.mobile"
              class="feed-input"
              style="width: 100%; margin: 5px 0"
            />
          </div>
          <div class="captcha-wrapper">
            <div style="flex:none">验证码：</div>
            <el-input v-model="captcha" style="width:200px;"></el-input>
            <img :src="captchaSrc" />
            <i class="el-icon-refresh" @click="refresh"></i>
          </div>
          <button class="feed-btn" @click="submitForm">提 交</button>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>您的反馈提交成功</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinsVerification } from "@/mixins/verification";
export default {
  name: "feedbackBut",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      feedback: true,
      captcha:'',
      commitForm: {
        content: "",
        mobile: "",
        imageUrls: "",
      },
      centerDialogVisible: false,
    };
  },
  mixins: [mixinsVerification],
  methods: {
    handleSuccess(response, file, fileList) {
      if (this.commitForm.imageUrls) {
        this.commitForm.imageUrls += "," + response.data.furl;
      } else {
        this.commitForm.imageUrls = response.data.furl;
      }
    },
    submitForm() {
      if (this.formCheck()) {
        _api.all.commitFeedback(this.commitForm, { captcha: this.captcha }).then((res) => {
          this.centerDialogVisible = true;
          this.commitForm = {
            content: "",
            mobile: "",
            imageUrls: "",
          };
        });
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    formCheck() {
      if (!this.commitForm.content) {
        this.$message({
          showClose: true,
          message: "意见或反馈内容不能为空",
          type: "error",
        });
        return false;
      } else if (!this.commitForm.mobile) {
        this.$message({
          showClose: true,
          message: "联系方式不能为空",
          type: "error",
        });
        return false;
      } else if (!/^1[3456789]\d{9}$/.test(this.commitForm.mobile)) {
        this.$message({
          showClose: true,
          message: "请输入正确的手机号码",
          type: "error",
        });
        return false;
      } else if (!this.captcha) {
        this.$message({
          showClose: true,
          message: "验证码不能为空",
          type: "error",
        });
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input-placeholder {
  color: #aaa;
  font-size: 16px;
}
.feedbackBut {
  position: fixed;
  bottom: 75px;
  right: 10px;
  color: #fff;
  border: 2px solid #fff;
  padding: 8px 13px 8px 10px;
  width: 80px;
  background: #4bc17c;
  border-radius: 20px;
  box-shadow: 0 0 8px #aaa;
  cursor: pointer;
  display: flex;
  z-index: 999;
  i {
    line-height: 20px;
    font-size: 20px;
  }
  p {
    padding-top: 3px;
  }
}
.feedbackCon {
  position: fixed;
  bottom: 7px;
  right: 7px;
  z-index: 99;
  width: 333px;
  background: #4bc17c;
  box-shadow: 0 0 8px #aaa;
  border-radius: 5px;
  padding-top: 10px;
  overflow: hidden;
  .content {
    background: #fff;
    padding: 10px;
    color: #aaa;
    .content-header {
      margin: 5px 0 10px;
      display: flex;
      justify-content: space-between;
      .icon-close {
        cursor: pointer;
      }
    }
    .opinion-input {
      width: 309px;
      height: 137px;
      min-height: 136px;
      max-height: 200px;
    }
    .feed-input {
      position: relative;
      display: inline-block;
      padding: 4px 7px;
      width: 100%;
      height: 28px;
      cursor: text;
      font-size: 12px;
      line-height: 1.5;
      background-color: #fff;
      background-image: none;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1),
        background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1),
        box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    .feed-btn {
      width: 100%;
      height: 35px;
      font-size: 14px;
      background-color: rgb(75, 193, 124);
      font-weight: bold;
      color: white;
      border-radius: 5px;
    }
    .pic-upload {
      margin: 10px 0;
      .pic-card {
        border: 1px dashed #d9d9d9;
        width: 96px;
        height: 96px;
        padding: 24px 0;
        border-radius: 6px;
        background-color: #fbfbfb;
        text-align: center;
        transition: border-color 0.3s ease;
        display: inline-block;
        vertical-align: top;
        margin-right: 8px;
        margin-bottom: 8px;
        position: relative;
        &:hover {
          border-color: #28cacb;
        }
        .card-input {
          opacity: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          cursor: pointer;
        }
        .anticon {
          display: inline-block;
          font-style: normal;
          vertical-align: baseline;
          text-align: center;
          text-transform: none;
          text-rendering: auto;
          line-height: 1;
        }
      }
    }
    .input-wrapper {
      margin: 5px 0;
    }
  }
}
.captcha-wrapper {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin: 10px 0;
  font-size: 12px;
}
</style>
<style lang="scss">
.el-upload-list__item {
  width: 96px !important;
  height: 96px !important;
}
.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
}
.el-icon-refresh {
  font-size: 20px;
}
</style>

